import React, { useContext } from 'react';
import { Modal } from 'antd';
import ClientsContext from '../../contexts/clients-context/ClientsContext';
import TableForm from './TableForm';
import './PageModal.scss';
import { useTranslation } from 'react-i18next';

const PageModal = () => {
  const { modalOpened, setModalOpened, selectedClient, setSelectedClient } =
    useContext(ClientsContext);
  const { t } = useTranslation();

  return (
    <Modal
      className="new-supplier-modal"
      width="90%"
      style={{ maxWidth: '642px' }}
      title={
        selectedClient
          ? t('ShopInvoice.editStore')
          : t('ShopInvoice.AddNewStore')
      }
      visible={modalOpened}
      onOk={() => {
        setModalOpened(false);
        setSelectedClient(null);
      }}
      onCancel={() => {
        setModalOpened(false);
        setSelectedClient(null);
      }}
      footer={false}
    >
      <TableForm />
    </Modal>
  );
};

export default PageModal;
